import React, { useEffect, useState } from 'react';
import AreteLogo from '../components/AreteLogo';
import { IconCheckCircle } from '../components/Icons';

const SUPABASE_URL  = process.env.REACT_APP_SUPABASE_URL  || '';
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON || '';

export default function SetPassword() {
  const [password, setPassword]     = useState('');
  const [confirm, setConfirm]       = useState('');
  const [error, setError]           = useState('');
  const [loading, setLoading]       = useState(false);
  const [tokenError, setTokenError] = useState('');
  const [accessToken, setAccessToken] = useState('');
  const [done, setDone]             = useState(false);

  useEffect(() => {
    const hash   = window.location.hash;
    const params = new URLSearchParams(hash.slice(1));
    const token  = params.get('access_token');
    const type   = params.get('type');
    if (!token || (type !== 'recovery' && type !== 'invite')) {
      setTokenError('Invalid or expired link. Ask your administrator for a new one.');
      return;
    }
    setAccessToken(token);
    window.history.replaceState(null, '', '/set-password');
  }, []);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    const res = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        apikey: SUPABASE_ANON,
      },
      body: JSON.stringify({ password }),
    });
    setLoading(false);
    if (!res.ok) {
      const json = await res.json().catch(() => ({})) as { message?: string };
      setError(json.message || 'Failed to set password. The link may have expired.');
      return;
    }
    setDone(true);
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#1B3022' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="flex justify-center mb-4">
            <AreteLogo iconSize={52} fontSize="1.6rem" onDark={true} />
          </div>
          <p className="text-sm tracking-widest uppercase" style={{ color: 'rgba(198,210,190,0.45)' }}>Welcome to Arete</p>
        </div>
        <div className="rounded-3xl shadow-2xl p-8" style={{ background: 'rgba(245,248,242,0.97)', border: '1px solid rgba(214,224,207,0.45)' }}>
          {done ? (
            <div className="text-center">
              <div className="mb-4 flex justify-center"><IconCheckCircle size={40} color="#22C55E" /></div>
              <h2 className="text-arete-forest font-bold text-xl mb-2">Password set!</h2>
              <p className="text-arete-moss text-sm mb-6">Your account is ready.</p>
              <a href="/login" className="btn-primary block text-center">Go to Sign In</a>
            </div>
          ) : tokenError ? (
            <div className="text-center">
              <div className="text-red-500 font-semibold mb-3">Link Invalid or Expired</div>
              <p className="text-arete-moss text-sm">{tokenError}</p>
            </div>
          ) : (
            <>
              <h2 className="text-arete-forest font-bold text-xl mb-1">Set your password</h2>
              <p className="text-arete-moss text-sm mb-6">Choose a password to activate your account.</p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-xs font-bold text-arete-forest uppercase tracking-wider mb-1.5">Password</label>
                  <input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)}
                    placeholder="At least 8 characters" required autoFocus disabled={!accessToken} />
                </div>
                <div>
                  <label className="block text-xs font-bold text-arete-forest uppercase tracking-wider mb-1.5">Confirm Password</label>
                  <input className="input" type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                    placeholder="Repeat your password" required disabled={!accessToken} />
                </div>
                {error && <div className="bg-red-50 border border-red-100 text-red-600 rounded-xl px-4 py-3 text-sm">{error}</div>}
                <button type="submit" disabled={loading || !accessToken} className="btn-primary w-full">
                  {loading ? 'Setting password…' : 'Activate Account'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
